import { Container, Paper, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const RouteShell = ({ title, Icon, children, flat = false }) => {
    const { palette } = useTheme()
    const isDark = palette.mode === 'dark'

    const content = (
        <>
            {
                title && (
                    <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: { xs: 1.5, md: 2 }, flexWrap: 'wrap' }}>
                        {Icon ? <Icon color="primary" /> : null}
                        <Typography variant="h5" sx={{ fontSize: { xs: '1.08rem', sm: '1.35rem', md: '1.45rem' }, lineHeight: 1.25, fontWeight: 800 }}>{title}</Typography>
                    </Stack>
                )
            }
            {children}
        </>
    )

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 1.25, sm: 1.8, md: 3 }, px: { xs: 1, sm: 2, md: 3 } }}>
            {
                flat ? content : (
                    <Paper
                        elevation={isDark ? 2 : 0}
                        sx={{
                            p: { xs: 1.25, sm: 1.75, md: 2.75 },
                            border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e6eaf2'}`,
                            background: isDark ? 'rgba(18,26,43,0.95)' : '#ffffff'
                        }}
                    >
                        {content}
                    </Paper>
                )
            }
        </Container>
    )
}

export default RouteShell
